<template>
  <div class="footer-area" style="margin-left: -15px; margin-right: -15px">
    <div class="footer-copy text-center">
      <div class="container">
        <div class="row">
          <div class="pull-left">
              <span>2017 - {{ currentYear }} © <a href="/">Lüco</a></span> 
          </div> 
          <div class="bottom-menu pull-right"> 
            <ul> 
              <li>
                <a class="wow fadeInUp animated animated" :href="$t('urls.site_notice')" data-wow-delay="0.2s" style="visibility: visible; animation-delay: 0.2s; animation-name: fadeInUp;">
                  {{ $t('labels.site_notice') }}
                </a>
              </li> 
              <li>
                <a class="wow fadeInUp animated animated" :href="$t('urls.general_terms')" target="_blank" data-wow-delay="0.2s" style="visibility: visible; animation-delay: 0.2s; animation-name: fadeInUp;">
                  {{ $t('labels.general_terms') }}
                </a>
              </li>
              <li>
                <a class="wow fadeInUp animated animated" :href="$t('urls.privacy')" data-wow-delay="0.3s" style="visibility: visible; animation-delay: 0.3s; animation-name: fadeInUp;">
                  {{ $t('labels.privacy') }}
                </a>
              </li>
            </ul> 
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import moment from 'moment'
import { computed } from 'vue'

const currentYear = computed(() => {
	return moment().format('YYYY')
})
</script>